import axios from '../axios'

// コース内クイズ一覧（モジュール順）
const getCourseQuizzesApi = async (courseId) => {
  return await axios.get(`api/lms/courses/${courseId}/quizzes`)
}

export default getCourseQuizzesApi
